/* eslint-disable @typescript-eslint/no-explicit-any */
import { ItemContainer, ItemContainerMain } from "./styled";
import MemoizedImageRaratyCommon from 'shared/MemoizedImage/RaratyCommon'
import MemoizedImageRaratyEpic from 'shared/MemoizedImage/RaratyEpic'
import MemoizedImageRaratyLegendary from 'shared/MemoizedImage/RaratyLegendary'
import MemoizedImageRaratyMythic from 'shared/MemoizedImage/RaratyMythic'
import MemoizedImageRaratyRare from 'shared/MemoizedImage/RaratyRare'
import { ShopTypeRariTy } from 'models'
interface itemProp {
  imgUrl: string
  onClickItem: () => void
  className?: any
  imgDefault?: string
  horseItem?: any
  name?: string
  rarityType?: string
  isRaritySmall?: boolean 
}

const Item = ({ imgUrl, onClickItem, className, imgDefault = '', horseItem = '', name = '', rarityType, isRaritySmall}: itemProp) => {

  const truncateMiddle = (str: string, startLen: number) => {
    const hashIndex = str.indexOf('#');
    if (hashIndex === -1) return str.length > startLen ? str.substring(0, startLen) + '...' : str;
    const suffix = str.substring(hashIndex); 
    const prefix = str.substring(0, startLen);
    if (str.length <= startLen + suffix.length) return str;
    return prefix + '...' + suffix;
  };

  const showIconRariTy = () => {
    const valueRariry = rarityType
    const handleKeySort = () => {
      switch (valueRariry) {
        case ShopTypeRariTy.ALL:
          return ''
        case ShopTypeRariTy.COMMON.toLocaleUpperCase(): {
          return <MemoizedImageRaratyCommon />
        }
        case ShopTypeRariTy.EPIC.toLocaleUpperCase(): {
          return <MemoizedImageRaratyEpic />
        }
        case ShopTypeRariTy.LEGENDARY.toLocaleUpperCase(): {
          return <MemoizedImageRaratyLegendary />
        }
        case ShopTypeRariTy.MYTHIC.toLocaleUpperCase(): {
          return <MemoizedImageRaratyMythic />
        }
        case ShopTypeRariTy.RARE.toLocaleUpperCase(): {
          return <MemoizedImageRaratyRare />
        }
        default:
          return valueRariry
      }
    }
    return handleKeySort()
  }
  const bgIconRariTy = () => {
    const valueRariry = rarityType
    const handleKeySort = () => {
      switch (valueRariry) {
        case ShopTypeRariTy.ALL:
          return ''
        case ShopTypeRariTy.COMMON.toLocaleUpperCase(): {
          return 'bg-common'
        }
        case ShopTypeRariTy.EPIC.toLocaleUpperCase(): {
          return 'bg-epic'
        }
        case ShopTypeRariTy.LEGENDARY.toLocaleUpperCase(): {
          return 'bg-legendary'
        }
        case ShopTypeRariTy.MYTHIC.toLocaleUpperCase(): {
          return 'bg-mythic'
        }
        case ShopTypeRariTy.RARE.toLocaleUpperCase(): {
          return 'bg-rare'
        }
        default:
          return ''
      }
    }
    return handleKeySort()
  }
  return (
    <ItemContainerMain>
      <ItemContainer
        color={
          horseItem?.own_status === "OWNER"
            ? "#00f7f6"
            : (horseItem?.own_status === "IN_LENDING" || horseItem?.own_status === "IN_GUILD")
              ? "#cc661d"
              : isRaritySmall ? "#3ca942" : "#515460"}
        onClick={onClickItem}
        className={`${className} ${!isRaritySmall && bgIconRariTy()}`}
      >
        <div className="img-box">
          <img src={imgUrl} className={`${imgDefault ? "img-default" : ""} ${name ? "img-name" : ""}`} alt="icon" />
        </div>
      </ItemContainer>
      {rarityType &&
          <div className={`${isRaritySmall ? 'rarity-small' : 'rarity'}`}>
            {showIconRariTy()}
          </div>
        }
      {name &&
        <div className="name-item">{truncateMiddle(name, 12)}</div>
      }
    </ItemContainerMain>
  )
};

export default Item;